import { FascicoloFull } from "src/app/common/models/fascicolo/fascicolo-full";

export class DialogConfig {
  data?: DialogConfigType;
}

interface DialogConfigType extends GenericDialgConfig  {
  /** N.B specificare la width della dialog DEVE essere obbligatoria */
  style: {width: string, overflow?: boolean, height?: string , zIndex?: string}; // DA NON METTERE OPZIONALE
  panelTitle?: string;
  fascicolo?:FascicoloFull;

}

interface GenericDialgConfig {
  [key:string]: any;
}
